import React from "react";
import { IoLogoInstagram } from "react-icons/io5";
import { RiTiktokLine } from "react-icons/ri";
import { TbBrandYoutube } from "react-icons/tb";
import { FiFacebook } from "react-icons/fi";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <div className="bg-footer color_white font-family-montserrat container-footer">
      <div className="flex-container container-txt-footer1">
        <div className="txt-center img-logo div-nohidden">
          <img
            src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=LOGO%20COMPURED%202-04%20(1).webp&version_id=null"
            alt="laptop categoria"
            width="100px"
            className="logo-footer-sx"
          />
          <img
            src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=LOGO%20COMPURED%202-04%20(1).webp&version_id=null"
            alt="laptop categoria"
            width="160px"
            className="logo-footer-sm"
          />
        </div>
        <div className="flex-item txt-end img-responsive color_white_hover font9 
                        font400 txt-end group-1 txt-footer">
          <div>
            <Link to={`/terminos-y-condiciones`}>Términos y condiciones</Link >
          </div>

          <div className="margin-top-10">
            <Link to={`/libro-reclamaciones`}>Libro de reclamaciones</Link >
          </div>
          <div className="margin-top-10">
            <a href="#">Programa de afiliados</a>
          </div>
          <div className="margin-top-10">
            <Link to={`/catalogo-producto`}>Nuestros productos</Link >
          </div>
        </div>
        <div className="flex-item img-responsive color_white_hover font9 font400 
                        txt-end group-2 txt-footer">
          <div>
            <a href="#">Políticas de privacidad</a>
          </div>
          <div className="margin-top-10">
            <a href="#">Rastrear pedido</a>
          </div>
          <div className="margin-top-10">
            <Link to={`/contactanos`}>Contáctanos</Link >
          </div>
          <div className="margin-top-10">
            <Link to={`/iniciar-sesion`}>Iniciar sesión</Link >
          </div>
        </div>
      </div>

      <div className="container-txt-footer2">
        <div className="txt-center font10 font400  margin-top-25 pad-txt-24 txt-footer2">
          Encuentra los mejores productos de tecnología al mejor precio. Visita nuestras redes
          sociales para conocer descuentos y promociones.
        </div>

        <div className="txt-center font10 font300 margin-top-25 margin-top-footer padding-bottom-10 txt-footer2">
          Copyright © {new Date().getFullYear()}. Todos los derechos reservados
        </div>
      </div>
    </div>
  );
};
